import request from '../../utils/requests'
/** * Tag: OrgSite */
const baseUrl ="/api/orgsite";

/** * 新增 * @param {*} body * { *    OrgSiteId Desc:场地id Required:false *    Name Desc:场地名称 Required:true *    Sort Desc:排序 Required:false *    Remark Desc:备注 Required:false *    BranchId Desc:校区id Required:true * } */async function _add(body) {  return request(baseUrl+'/add',{    method: 'POST',    body: body,  });
}

/** * 更新 * @param {*} body * { *    OrgSiteId Desc:场地id Required:false *    Name Desc:场地名称 Required:true *    Sort Desc:排序 Required:false *    Remark Desc:备注 Required:false *    BranchId Desc:校区id Required:true * } */async function _update(body) {  return request(baseUrl+'/update',{    method: 'POST',    body: body,  });
}

/** * 删除单条数据 * @param {*} param * { *    orgSiteId Desc:场地id Required:true * } */async function _delete(param) {  return request(baseUrl+'/delete',{    method: 'GET',    params: param,  });
}

/** * 获取单条 * @param {*} param * { *    orgSiteId Desc: Required:true * } */async function _getModel(param) {  return request(baseUrl+'/getModel',{    method: 'GET',    params: param,  });
}

/** * 获取分页 * @param {*} body * { *    BranchId Desc:校区id Required:false *    OrgId Desc:机构id(后台使用) Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _paging(body) {  return request(baseUrl+'/paging',{    method: 'POST',    body: body,  });
}

/** * 批量删除 * @param {*} body * { *    IdList Desc:IDList Required:false *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false * } */async function _batchDelete(body) {  return request(baseUrl+'/batchDelete',{    method: 'POST',    body: body,  });
}

/** * 批量新增 * @param {*} body * { *    NameList Desc:场地id Required:false *    BranchId Desc:校区ID Required:true *    OrgId Desc:机构ID(后台使用) Required:false * } */async function _batchAdd(body) {  return request(baseUrl+'/batchAdd',{    method: 'POST',    body: body,  });
}

export default{  _add,  _update,  _delete,  _getModel,  _paging,  _batchDelete,  _batchAdd}



// WEBPACK FOOTER //
// ./src/services/orgsite.js